import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';
import { UtilsService } from 'src/app/utils.service';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menuList$: Observable<any[]> = of([]);
  profileData: any = []

  private menuSubject = new BehaviorSubject<any | null>({});
  menuSubject$ = this.menuSubject.asObservable();

  setMenuSubject(menu: any | null) {
    this.menuSubject.next(menu);
  }

  constructor(private http: HttpClient, private utilsService: UtilsService) {
    console.log("=====MENU CALLLING=====");
    this.utilsService.profileActionData.subscribe((data: any) => {
      console.log("RRRRR", data)
      this.profileData = data.profileData;
    })

  }

  // Private method to initialize and cache menu data
  private initializeMenu() {
    // const cachedMenu = JSON.parse(localStorage.getItem('products') || '[]');
    console.log("ROLE====", this.profileData.role)
    this.menuList$ = of([]); 
    let role = 'default';
    if (this.profileData.role !== undefined) {
      role = this.profileData.role
    }
    // this.menuList$ = this.http.get<any[]>('assets/data/menu_' + role.toLowerCase() + '.json').pipe(
    //   map(data => {
    //     console.log("========MENU==========", data)
    //     // localStorage.setItem('products', JSON.stringify(data));
    //     return data;
    //   }),
    //   startWith([])
    // );
    this.menuList$= this.http.get<any[]>('assets/data/menu_' + role.toLowerCase() + '.json').pipe(
      map(data => {
        console.log("========MENU==========", data);
        // localStorage.setItem('menu_' + role.toLowerCase(), JSON.stringify(data));
        this.setMenuSubject(data);
        return data;
      }),
      startWith([]),
      catchError(error => {
        console.error("Failed to load menu:", error);
        return of([]);  // Return an empty array in case of error
      })
    );
  }

  // Public getter to access menu items
  public get getMenu(): Observable<any[]> {
    this.initializeMenu();
    return this.menuList$;
  }
}
